import { SxProps, Theme, TypographyVariant } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { AttendanceCode } from '@schooly/api';
import { CircleText } from '@schooly/style';
import { FC } from 'react';

import { getAttendanceCodePalette } from './utils';

type AttendanceCodeCircleProps = {
  code?: AttendanceCode;
  size?: number;
  variant?: TypographyVariant;
  className?: string;
  sx?: SxProps<Theme>;
};

export const AttendanceCodeCircle: FC<AttendanceCodeCircleProps> = ({
  code,
  size,
  variant,
  className,
  sx,
}) => {
  const palette = code ? getAttendanceCodePalette(code) : undefined;

  return (
    <CircleText
      size={size}
      variant={variant}
      className={className}
      sx={(theme) => ({
        color: palette?.primary ?? theme.palette.common.grey,
        backgroundColor: palette?.secondary ?? theme.palette.background.paper,
        border: palette ? 'none' : `1px solid ${theme.palette.divider}`,
        ...((typeof sx === 'function' ? sx(theme) : (sx ?? {})) as SystemStyleObject),
      })}
    >
      {code?.code ?? ''}
    </CircleText>
  );
};
